const version = '1.2.4';
export default version;